import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { getUsersPreferenceByKeyThunk } from "@/store/user-preference/thunks/getUsersPreferenceByKeyThunk";
import { languagePreferenceKey } from "@/components/common/language-select/utils/constants/constants";

export const getLanguageThunk = createAsyncThunk(
  "languageSelect/getLanguageThunk",
  async (forceRefetch: boolean | void, { dispatch }) => {
    try {
      dispatch(
        getUsersPreferenceByKeyThunk({
          key: languagePreferenceKey,
          forceRefetch: !!forceRefetch,
        }),
      );
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
